import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/payroll/payslips/$payslipId',
}).lazy(() => import('./payslips.$payslipId.index.lazy').then((d) => d.Route))
